enum GoogleMapsMarkerColorEnum {
    BLACK = "black",
    BROWN = "brown",
    GREEN = "green",
    PURPLE = "purple",
    YELLOW = "yellow",
    BLUE = "blue",
    GRAY = "gray",
    ORANGE = "orange",
    RED = "red",
    WHITE = "white",
}

export default GoogleMapsMarkerColorEnum;
